import type { ReactNode } from 'react';

import styles from './PortalComponents.module.css';

export function EmptyState({
  title,
  children,
}: {
  title: string;
  children?: ReactNode;
}): React.JSX.Element {
  return (
    <div className={styles.emptyState}>
      <p className={styles.emptyStateTitle}>{title}</p>
      {children !== undefined && <p className={styles.emptyStateBody}>{children}</p>}
    </div>
  );
}
